import {Able, MoveableManagerInterface} from "moveable";
import {Renderer} from "react-moveable/types";
import React from "preact/compat";
import Interactable from "../interactable";
import util, {roundTo25} from "../../util";
import {ABLE_OFFSET} from "../interactable-constants";

interface DimensionViewableProps {
  dimensionViewable: boolean;
  interactable: Interactable;
}

const DimensionViewable = {
  name: "dimensionViewable",
  props: {
    parentScale: Number,
    interactable: Interactable
  },
  render(moveable: MoveableManagerInterface<DimensionViewableProps>, _renderer: Renderer) {
    const rect = moveable.getRect();
    const interactable = moveable.props.interactable;
    const isPX = util.getActiveDimensions().unit === 'px';

    const scale = interactable.getFrame().scale[0] || 1;
    const id = interactable.getElement().attr('id');

    let width = 0;
    let height = 0;
    if (isPX) {
      width = parseFloat(interactable.getElement().attr('data-px-width') || '0') * scale;
      height = parseFloat(interactable.getElement().attr('data-px-height') || '0') * scale;
    } else {
      width = parseFloat(interactable.getElement().attr('data-inch-width') || '0') * scale;
      height = parseFloat(interactable.getElement().attr('data-inch-height') || '0') * scale;
    }
    if (!height && !width) {
      width = util.pixelToInch(Math.round((rect.offsetWidth || 0) * scale));
      height = util.pixelToInch(Math.round((rect.offsetHeight || 0) * scale));
    }

    const widthString = isPX ? parseInt(`${width}`) : roundTo25(width);
    const heightString = isPX ? parseInt(`${height}`) : roundTo25(height);

    return <div key={id} className={"moveable-dimension"} style={{
      position: "absolute",
      left: `${rect.width / 2}px`,
      top: `${rect.height + ABLE_OFFSET.DIM}px`,
      background: "rgba(252,95,87,.75)",
      borderRadius: "8px",
      padding: "2px 10px",
      color: "white",
      fontSize: "13px",
      whiteSpace: "nowrap",
      fontWeight: "bold",
      willChange: "transform",
      transform: "translate(-50%, 0px)",
      display: "none",
      zIndex: 2
    }}>
      W: {widthString} H: {heightString}
    </div>
  },
} as Able;

export default DimensionViewable;
